import { render, staticRenderFns } from "./VehicleImage.vue?vue&type=template&id=48c53d8a"
import script from "./VehicleImage.vue?vue&type=script&lang=js"
export * from "./VehicleImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports